export default __webpack_public_path__ + "static/media/timezone-icon-white.783fd513.svg";